import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/admin/backAccounts/login',
    method: 'post',
    data
  })
}

export function getInfo(id) {
  return request({
    url: `/admin/backAccounts/${id}`,
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/backAccounts/logout',
    method: 'post'
  })
}

// c端账户
export function fetchList(params) {
  return request({
    url: '/admin/backAccounts/pageAccount',
    method: 'post',
    data: params
  })
}

// 后台账户
export function fetchBackAccounts(params) {
  return request({
    url: '/admin/backAccounts/pageBackAccount',
    method: 'post',
    data: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/backAccounts',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

// 更新密码
export function updatePassword(id, data) {
  return request({
    url: `/admin/backAccounts/${id}/password`,
    method: 'put',
    data: data
  })
}

export function deleteAdmin(id) {
  return request({
    url: `/admin/backAccounts/${id}`,
    method: 'delete'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

// 获取权限申请列表
export function getApplyList(data) {
  return request({
    url: '/admin/backAccounts/pageAccountAuth',
    method: 'post',
    data: data
  })
}

// 审核账户权限
export function updateStatus(id, authStatus, params) {
  return request({
    url: `/admin/backAccounts/${id}/${authStatus}`,
    method: 'put',
    params
  })
}

// 修改c端用户备注
export function updateAdminRemark(userId, params) {
  return request({
    url: `/admin/backAccounts/${userId}/updateAdminRemark`,
    method: 'put',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js